import { render, staticRenderFns } from "./ChangeOwnershipByVehicleSegment.vue?vue&type=template&id=29669b92"
import script from "./ChangeOwnershipByVehicleSegment.vue?vue&type=script&lang=js"
export * from "./ChangeOwnershipByVehicleSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports